import { apiClient } from "./ApiClient";

const buildMultipleOrderBody = (items) => {
  return items.reduce((acc, item) => {
    const packageId = String(item.internal_package_id || item.id);
    acc[packageId] = item.quantity || 1;
    return acc;
  }, {});
};

export async function createWalletOrder({ internalPackageId, walletId, promocode = null }) {
  const params = {
    package_id: internalPackageId,
    wallet_id: walletId,
    promocode: promocode || null,
  };

  const { data } = await apiClient.post("/order/", null, { params });
  return data;
}

export async function createWalletMultipleOrder({ items, walletId, promocode = null }) {
  const params = {
    wallet_id: walletId,
    promocode: promocode || null,
  };

  const body = buildMultipleOrderBody(items);

  const { data } = await apiClient.post("/order/multiple", body, { params });
  return data;
}

export async function initiateGuestOrder({
  internalPackageId,
  userId,
  frontendUrl,
  turnstileToken,
  provider = "stripe",
}) {
  const params = {
    package_id: internalPackageId,
    user_id: userId,
    frontend_url: frontendUrl,
    turnstile_token: turnstileToken,
    provider,
  };

  const { data } = await apiClient.post("/order/guest/init/secure", null, { params });

  return data;
}

export async function initiateGuestMultipleOrder({
  items,
  userId,
  frontendUrl,
  turnstileToken,
  currency = "EUR",
  provider = "stripe",
  newsletter = false,
}) {
  const params = {
    user_id: userId,
    frontend_url: frontendUrl,
    turnstile_token: turnstileToken,
    provider,
    currency,
    newsletter,
  };

  const body = buildMultipleOrderBody(items);

  const { data } = await apiClient.post("/order/guest/init/multiple/secure", body, { params });
  return data;
}

export async function initiateUserStripeOrder({ internalPackageId, walletId, frontendUrl, promocode = null }) {
  const body = {
    package_id: internalPackageId,
    wallet_id: walletId,
    frontend_url: frontendUrl,
    promocode: promocode || null,
    provider: "stripe",
  };

  const { data } = await apiClient.post("/order/init", body, {});
  return data;
}

export async function initiateUserStripeMultipleOrder({
  items,
  walletId,
  frontendUrl,
  promocode = null,
  provider = "stripe",
  paymentInApp = false,
}) {
  const body = {
    package_ids: buildMultipleOrderBody(items),
    wallet_id: walletId,
    frontend_url: frontendUrl,
    promocode: promocode || null,
    provider,
    payment_in_app: paymentInApp,
  };

  const { data } = await apiClient.post("/order/init/multiple", body);
  return data;
}
